var map = {
	"./AnanthaVikatan.pdf": 87097,
	"./BW2022.pdf": 5345,
	"./BWorld2023.pdf": 19883,
	"./CSR2023.pdf": 54101,
	"./Career3602022.pdf": 30835,
	"./Career360_2023.pdf": 37175,
	"./Career360_2023Bbest.pdf": 67877,
	"./Career360_2024.pdf": 67340,
	"./Chronicale2022.pdf": 76454,
	"./EW2022.pdf": 74000,
	"./EducationWorld2023.pdf": 67299,
	"./IndiaToday2022.pdf": 97608,
	"./IndiaToday2023.pdf": 84701,
	"./IndiaTodayMDRA.pdf": 17006,
	"./NIRF2021.pdf": 47992,
	"./NIRF2022.pdf": 46591,
	"./NIRF_2023.pdf": 13715,
	"./ReadersDigest2023.pdf": 50009,
	"./TheWeek2022.pdf": 40301,
	"./TheWeek2023.pdf": 69816,
	"./TheWeekHansa2023.pdf": 69119,
	"./Times2022.pdf": 8426,
	"./Times2023.pdf": 51111,
	"./ariia2020.pdf": 47178,
	"./career3602016.pdf": 18978,
	"./career3602017.pdf": 18559,
	"./careers360-aaaplus.pdf": 98616,
	"./careers360_042015.pdf": 32039,
	"./csr12.pdf": 44131,
	"./csr2015.pdf": 11266,
	"./csr2016.pdf": 23693,
	"./csr2017.pdf": 51320,
	"./csr2018.pdf": 45603,
	"./csr2020.pdf": 90762,
	"./csrjune2019.pdf": 2614,
	"./eduworld2020.pdf": 86802,
	"./india_today_2020.pdf": 67600,
	"./kecher.pdf": 16550,
	"./nirf2017.pdf": 61187,
	"./nirf2018.pdf": 66904,
	"./nirf2019.pdf": 55629,
	"./nirf2020.pdf": 25229,
	"./nirfranking.pdf": 33601,
	"./outlook2014.pdf": 50742,
	"./outlook2015.pdf": 48659,
	"./outlook_ranking_july_2014.pdf": 66665,
	"./theweek2016.pdf": 73256,
	"./theweek2017.pdf": 34173,
	"./theweek2020.pdf": 75839,
	"./toi_ter2015.pdf": 56126,
	"./toi_ter2015_57.pdf": 52653,
	"./week2015.pdf": 8106,
	"./week2019.pdf": 39070,
	"./week32.pdf": 42049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54882;